<template>
  <div class="supplement content-wrapper">
    <div class="page-header">{{ $t('editTransfer') }}</div>
    <div style="margin-bottom: 40px; margin-left: 5px;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'HotelTransferList' }">{{ $t('transferList') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('editTransfer') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" label-width="150px" style="width: 500px">
      <el-form-item :label="$t('name')" :required="true">
        <el-input v-model="transfer.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('price')">
        <el-input v-model="transfer.price" type="number"></el-input>
      </el-form-item>
      <el-form-item :label="$t('unit')">
        <el-select v-model="transfer.unitType">
          <el-option :label="transferType.title" :value="transferType.id" v-for="transferType in transferTypeList" :key="transferType.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('minPax')">
        <el-input v-model="transfer.minPax" type="number"></el-input>
      </el-form-item>
      <el-form-item :label="$t('maxPax')">
        <el-input v-model="transfer.maxPax" type="number"></el-input>
      </el-form-item>
      <el-form-item :label="$t('conditionDetail')">
        <el-input type="textarea" :rows="3" v-model="transfer.conditionDetail"></el-input>
      </el-form-item>
      <el-form-item :label="$t('status')">
        <el-radio-group v-model="transfer.isEnable" fill="#ff0000" >
          <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
          <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="onUpdateTransferButtonClick">{{ $t('updateTransfer') }}</el-button>
        <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { STATUS, TRANSFER_TYPE } from '@/configs/constant'
import i18nMessages from '@/translations/Hotel/ManageHotel/Transfer/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute, transferTypeList } from '@/services/hotel-service'
import HotelTransferApi from '@/api/hotel/transfer-api'
import { mapState } from 'vuex'

export default {
  name: 'HotelTransferAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { },
  i18n: { messages: i18nMessages },
  props: {
    transfer: {
      type: Object,
      default: function () {
        return {
          id: '',
          name: '',
          price: 0,
          unitType: TRANSFER_TYPE.PER_CAR,
          minPax: 1,
          maxPax: 1,
          conditionDetail: '',
          isEnable: STATUS.ENABLE
        }
      }
    }
  },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    if (this.transfer.id === undefined || this.transfer.id === '') {
      return this.$router.push({
        name: 'HotelTransferList'
      })
    }
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  data () {
    return {
      STATUS,
      transferTypeList
    }
  },
  methods: {
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelTransferList'
      })
    },
    onUpdateTransferButtonClick: async function () {
      try {
        this.startLoading()

        await HotelTransferApi.update(this.activeHotelId, this.transfer.id, this.transfer)
        this.$router.push({
          name: 'HotelTransferList'
        })

        const title = this.$t('updateTransferSuccessTitle')
        const message = this.$t('updateTransferSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
